// extracted by mini-css-extract-plugin
export default {"button":"button-VyW3Z","disabled":"disabled-QpyRB","color-success":"color-success-wDeAa"};